import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import AndroidOutlinedIcon from "@mui/icons-material/AndroidOutlined";
import PhoneIphoneOutlinedIcon from "@mui/icons-material/PhoneIphoneOutlined";

import { PLATFORM_UI_DESCRIPTIONS } from "./coupons";

export const PLATFORM_ICONS = {
  web: LanguageOutlinedIcon,
  android: AndroidOutlinedIcon,
  ios: PhoneIphoneOutlinedIcon,
};

export const PLATFORM_META = Object.fromEntries(
  Object.entries(PLATFORM_UI_DESCRIPTIONS).map(([key, description]) => [
    key,
    { icon: PLATFORM_ICONS[key], description },
  ])
);
